import React from 'react';

//Hooks

import { Link } from 'react-router-dom';

const FrontPage = () => {
  return (

        <div className="app-container">
          <div className="rectangle">
          <img src="tips-final.jpg" alt="Logo" />
          </div>
          <div className="shift">
            <Link to='/am' className="am">AM</Link>
            <Link to='/pm' className="pm">PM</Link>
          </div>
          
          <div className="by">
            <img src="rmf.png" alt="Logo" />
          </div>
          <div>Version 3.0 (June 2026)</div>
        </div>

  );
};

export default FrontPage;


